// Partenaire invité (spec § 3) : pas de pipeline, une liste des affaires transmises avec leur dernière note.

type NoteLike = {
  deal_id: unknown;
  date?: string | null;
  text?: string | null;
};

/** Note la plus récente de chaque affaire, par identifiant d'affaire. */
export const lastNoteByDeal = <T extends NoteLike>(notes: T[]) => {
  const last = new Map<string, T>();
  for (const note of notes) {
    const key = String(note.deal_id);
    const current = last.get(key);
    if (!current || (note.date ?? "") > (current.date ?? ""))
      last.set(key, note);
  }
  return last;
};
